<div class="card">
    <p-table [value]="aditamentos" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Número</th>
          <th>Etapa</th>
          <th>Situação</th>
          <th>Solicitante</th>
          <th>Data Criação</th>
          <th>Última Tramitação</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-aditamento>
        <tr>
          <td>{{ aditamento.numero }}</td>
          <td>{{ aditamento.etapa }}</td>
          <td>{{ aditamento.situacao }}</td>
          <td>{{ aditamento.solicitante }}</td>
          <td>{{ aditamento.dataCriacao | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ aditamento.dataUltimaTramitacao | date: 'dd/MM/yyyy HH:mm' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>